import React, { useState, useRef, useCallback } from 'react';
import { Modal, Button } from 'react-bootstrap';
import QRCode from 'qrcode';

interface ModalQRCodeProps {
  show: boolean;
  onHide: () => void;
  url: string;
}

const ModalQRCode: React.FC<ModalQRCodeProps> = ({ show, onHide, url }) => {
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState<string>('');
  const canvasRef = useRef<HTMLCanvasElement>(null);

  const generateQRCode = useCallback(async () => {
    if (!canvasRef.current) return;

    try {
      const canvas = canvasRef.current;
      
      const options = {
        width: 256,
        margin: 2,
        color: {
          dark: '#000000',
          light: '#FFFFFF'
        },
        errorCorrectionLevel: 'M' as const
      };

      await QRCode.toCanvas(canvas, url, options);
      
      const dataUrl = canvas.toDataURL('image/png');
      setQrCodeDataUrl(dataUrl);
    } catch (error) {
      console.error('Erro ao gerar QR Code:', error);
    }
  }, [url]);


  const downloadQRCode = () => {
    if (!qrCodeDataUrl) return;

    const link = document.createElement('a');
    link.download = 'qr-code-pre-cadastro.png';
    link.href = qrCodeDataUrl;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  React.useEffect(() => {
    if (show) {
      generateQRCode();
    }
  }, [show, generateQRCode]);

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="mdi mdi-qrcode me-2"></i>
          QR Code - Link de Pré-cadastro
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body className="text-center">
        <div className="mb-3">
          <p className="text-muted mb-3">
            Escaneie o QR Code abaixo para acessar o link de pré-cadastro de pacientes:
          </p>
          
          <div className="d-flex justify-content-center">
            <canvas
              ref={canvasRef}
              style={{
                border: '1px solid #dee2e6',
                borderRadius: '8px',
                backgroundColor: '#ffffff',
                maxWidth: '100%',
                height: 'auto'
              }}
            />
          </div>
        </div>

        <div className="mb-3">
          <small className="text-muted">
            <strong>URL:</strong> {url}
          </small>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          <i className="mdi mdi-close me-1"></i>
          Fechar
        </Button>
        <Button 
          variant="primary" 
          onClick={downloadQRCode}
          disabled={!qrCodeDataUrl}
        >
          <i className="mdi mdi-download me-1"></i>
          Baixar QR Code
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalQRCode;
